<template>
  <div>

    <div v-show="visible" class="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-screen tw-overflow-auto tw-bg-light tw-z-50">
      <div class="tw-w-full ">
        <div class="tw-flex tw-items-center tw-space-x-2 tw-py-5 tw-px-6 tw-border-b tw-border-light-2">
          <button v-on:click="visible = !visible">
            <i class="bx bx-left-arrow-alt tw-text-4xl tw-relative tw-top-1"></i>
          </button>
          <div class="tw-text-3xl tw-uppercase tw-font-bold">Menu</div>
        </div>
        <div>
          <slot name="header"></slot>
        </div>
        <div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data: v => ({
      visible: false,
    }),
    created() {
      // TODO check why not working
      let clickListener = e => {
        let clickedInComponent = (e.target === this.$el) || e.target.includes(this.$el);
        !clickedInComponent && (this.show = false)
      }
      document.addEventListener('click', clickListener)
      this.$on('hook:beforeDestroy', document.removeEventListener('click', clickListener))

      this.$watch('visible', value => {
        value && document.body.classList.add('overflow-hidden')
        !value && document.body.classList.remove('overflow-hidden')
      })

      let openCallback = e => (this.visible = true)
      document.addEventListener('open-aside', openCallback)
      this.$on('hook:beforeDestroy', () => document.removeEventListener('open-aside', openCallback))

    },
  }
</script>
